import { ChangeDetectionStrategy, ChangeDetectorRef, Component, effect, inject, input, model, OnInit, output } from '@angular/core';
import { CustomUserRegistrationModule } from "../../custom-user-registration/custom-user-registration.module";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { I18nModule } from "@spartacus/core";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { faPenToSquare } from "@fortawesome/free-regular-svg-icons";
import { NgClass } from "@angular/common";
import * as _ from 'lodash';
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";
import { ICON_TYPE, IconModule } from "@spartacus/storefront";

@Component({
  selector: 'sanofi-phone-section',
  standalone: true,
  imports: [
    CustomUserRegistrationModule,
    FaIconComponent,
    I18nModule,
    ReactiveFormsModule,
    NgClass,
    NgbPopover,
    IconModule
  ],
  templateUrl: './phone-section.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PhoneSectionComponent implements OnInit {
  private readonly cdr = inject(ChangeDetectorRef);

  phoneEditIsNotClicked = model<boolean>(false);
  accountPhoneNumber = input.required<string>();
  mobileErrorMsg = input(null);

  updatePhoneNumber = output<any>();
  removePhoneNumber = output<any>();
  editBtnClick = output<boolean>();

  phoneForm: FormGroup;

  protected readonly faPenToSquare = faPenToSquare;
  readonly PHONE_INPUT_ID = 'phoneId';

  constructor() {
    effect(() => {
      if (this.accountPhoneNumber()?.length) {
        this.phoneForm.get(this.PHONE_INPUT_ID).patchValue(this.accountPhoneNumber());
        this.cdr.detectChanges();
      }
      if (this.phoneEditIsNotClicked()) {
        this.resetPhoneForm();
      }
    });
  }

  ngOnInit(): void {
    this.phoneForm = new FormGroup({
      [this.PHONE_INPUT_ID]: new FormControl(this.accountPhoneNumber(), [
        Validators.required,
        Validators.minLength(12),
        Validators.maxLength(12)
      ]),
    });
  }

  resetPhoneForm() {
    this.phoneForm.reset();
    this.phoneForm
      .get(this.PHONE_INPUT_ID)
      .patchValue(this.accountPhoneNumber());
  }

  cancelPhoneUpdate() {
    this.phoneEditIsNotClicked.set(true);
    this.resetPhoneForm();
  }
  updatePhoneField() {
    const params = {
      mobileNumber: _.replace(this.phoneForm.get(this.PHONE_INPUT_ID).value, /\D/g, ''),
      profileUpdateType: 'MOBILE_CHANGE_REQUEST',
    };

    this.updatePhoneNumber.emit(params);
    this.phoneEditIsNotClicked.set(true);
  }
  editPhoneField() {
    this.editBtnClick.emit(true);
  }

  removeMobile(popover: NgbPopover) {
    this.removePhoneNumber.emit(true);
    popover.close();
  }

  protected readonly ICON_TYPE = ICON_TYPE;
}
